import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.rotating-vehicle' ).each( function( key, component ) {
        const splide = new Splide( component, {
          type: 'fade',
          pagination: false,
          arrows: true,
          gap: '0px',
          autoWidth: false,
          perPage: 1,
          speed: 1000,
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'rotating-vehicle', COMPONENT );
} )( app );
